import React from 'react';
import ReactTooltip from 'react-tooltip';
import COLORS from '../../constants/colors';

export default function Tooltip() {
  return (
    <ReactTooltip className="tooltip" effect="solid" place="right" type="info" backgroundColor={COLORS.backgroundTurquoise} />
  );
}
